import React from "react";
//#region types
import { AgentReply } from "models/agent/agentContract";
import { KeyValue } from "models/utilTypes/keyValue";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { DetailsTableViewSmall } from "components/common";
import AgentAnswerText from "./agentAnswerText";
import { cardDetails } from "./agentCardComponents";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const AgentAnswerCard: React.FC<{ reply: AgentReply }> = ({ reply }) => {
  if (reply.kind === "card") {
    const rows = reply.components?.length
      ? cardDetails(reply.components)
      : reply.rows.map((row) => new KeyValue<string | undefined, string>(row.label, row.value));
    return (
      <Grid container direction="column" className={cssExports.agentWhiteCard}>
        <span className={cssExports.agentWhiteCardTitle}>{reply.title}</span>
        <DetailsTableViewSmall detailsList={rows} hideButton />
      </Grid>
    );
  }

  const text = reply.kind === "receipt" ? reply.body : reply.kind === "answer" ? reply.text : "";
  return (
    <Grid container className={cssExports.agentWhiteCard}>
      <AgentAnswerText text={text} />
    </Grid>
  );
};

export default AgentAnswerCard;
